import React from 'react'
import {
  IconSystemCards,
  IconSystemFlowers,
  IconSystemGift,
  IconSystemSearch,
} from '@moonpig/launchpad-assets'
import { DepartmentsEnum } from '@moonpig/web-core-types-graphql'
import { LIST_ICON_SIZE_PX } from './constants'

export const mapDepartmentToIcon = (
  department: DepartmentsEnum,
): React.JSX.Element => {
  const iconProps = {
    width: LIST_ICON_SIZE_PX,
    height: LIST_ICON_SIZE_PX,
  }

  switch (department) {
    case 'ALL_CARDS':
      return <IconSystemCards {...iconProps} />

    case 'ALL_GIFTS':
      return <IconSystemGift {...iconProps} />

    case 'ALL_FLOWERS_AND_PLANTS':
      return <IconSystemFlowers {...iconProps} />

    /* istanbul ignore next */
    default:
      return <IconSystemSearch {...iconProps} />
  }
}
